import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_6: FaireProductEntity = {
  token: "starter_collection_6",
  type: "product",
  name: "'\"Frizzle\" Squeeze'",
  brandName: "Graza",
  imageUrl: "",
  priceDollars: 14,
  msrpDollars: 28,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
